const axios = require("axios");
const { getBaseUrl } = require("./baseUrl");
const ACCESS_TOKEN = process.env.ACCESS_TOKEN || process.env.REACT_APP_ACCESS_TOKEN;
/* NodeJS */
/* Proxy */
// const url = `${process.env.REACT_APP_BASE_PROXY_URL}/properties`

module.exports = {
  getStore: (puid, uid, expireKey, language, categoriesOnly) =>
    getBaseUrl().then((url) =>
      axios({
        method: "GET",
        url: `${url}/store?puid=${puid}&uid=${uid}&k=${expireKey}&type=Store&language=${language}&categories_only=${categoriesOnly ?? false}`,
        headers: { "Authorization": "Bearer " + ACCESS_TOKEN },
      })
    ),
  getStoreByCategory: (uid, language) =>
    getBaseUrl().then((url) =>
      axios({
        method: "GET",
        url: `${url}/store?category_uid=${uid}&type=Store&language=${language}`,
      })
    ),
  getPreset: (puid) =>
    getBaseUrl().then((url) =>
      axios({
        method: "GET",
        url: `${url}/preset/list?uid=${puid}`
      })
    )
}